import React from 'react';
import styled from 'styled-components';

import messages from './messages';
import { getCellBackgroundColour } from '../../SellingRateCalendarPage/utils';

import { FormattedDate, FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';

const CellContainer = styled.div`
    cursor: ${(props) => (props.hasRecommendation ? 'pointer' : 'default')};
    font-weight: bold;
    padding: 0 12px 5px 0;

    color: ${(props) => (props.outsideRange ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.85)')};

    /* Revert calendar disabled CalendarCell effect */
    pointer-events: auto;
`;

const CalendarCell = ({ date, hasRecommendation, outsideRange, priority }) => {
    const navigate = useNavigate();

    const navigateToRateCalendar = () => {
        navigate('/app/sellingRateCalendar', { state: { preselectedDate: date } });
    };

    const containerStyle = {};
    const cellColour = getCellBackgroundColour(priority);
    containerStyle.background = `linear-gradient(to top left,#0000 50%,${cellColour} 50.1%) top left/10px 10px no-repeat`;
    containerStyle.borderTop = `2px solid ${cellColour}`;

    if (!hasRecommendation)
        return (
            <CellContainer outsideRange={outsideRange}>
                <FormattedDate value={date} day="2-digit" />
            </CellContainer>
        );
    return (
        <Tooltip title={<FormattedMessage {...messages.availableRecommendation} />}>
            <CellContainer
                hasRecommendation={hasRecommendation}
                outsideRange={outsideRange}
                style={containerStyle}
                onClick={() => navigateToRateCalendar()}
            >
                <FormattedDate value={date} day="2-digit" />
            </CellContainer>
        </Tooltip>
    );
};

export default CalendarCell;
